import { THIN_BORDER } from 'constants/global';

import Steps from 'assets/icons/steps.svg';
import Warning from 'assets/icons/warning.svg';
import CheckCircled from 'assets/icons/check_circled.svg';

export const defaultCardsData = [
  { icon: Warning, title: 'Когда это нужно', cardProps: { bgColor: 'bg.grayLight' } },
  { icon: CheckCircled, title: 'Что вы получите', cardProps: { bgColor: 'bg.gray' } },
  {
    icon: Steps,
    title: 'Процесс работы',
    cardProps: { colSpan: { tablet: 2 }, border: THIN_BORDER, borderColor: 'line.gray' },
    iconCircleBoxProps: { bgColor: 'bg.grayLight' },
  },
];
